import { HttpBadStatusCodeError, IParams } from '@cian/peperrors/shared';

/**
 * Выбрасывает исключение
 */
export const throwError = (params: IParams) => {
  throw new HttpBadStatusCodeError(params);
};
